import Image from "next/image";
import classnames from "classnames";
import styles from "./gallery.module.css";

export default function GalleryCard({ showModal, image }) {
  return (
    <a
      className="block overflow-hidden rounded"
      href={`https://images.opencoaster.com/1600x/${image.hash}${image.ext}`}
      onClickCapture={(e) => {
        e?.preventDefault();
        showModal(image);
      }}
      key="Gallery-0"
    >
      <figure className={classnames("relative", styles.figure)}>
        <Image
          src={`https://images.opencoaster.com/800x/${image.hash}${image.ext}`}
          alt={image.alternativeText}
          layout="intrinsic"
          height={image.height}
          width={image.width}
          unoptimized
        />
        <figcaption
          className={classnames(
            "absolute bottom-0 right-0 p-1 font-mono text-white text-opacity-75",
            styles.caption
          )}
        >
          {image.caption}
        </figcaption>
      </figure>
    </a>
  );
}
